/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  ActionShowHide,
  LeftSiderBarHeader,
  LeftSiderBarHeaderGroup,
  LeftSiderBarWrap,
} from '@components/LeftSideBar/LeftSiderBar.style';
import CourseSelect from '@containers/CourseSelect';
import SectionSelect from '@containers/SectionSelect';
import ExamSectionsWrapper from '@components/Component/ExamSections/ExamSections';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectors, actions } from '@reducers/leftSideBar';
import MediaQuery from 'react-responsive';
import Box from '@components/Atoms/Box';
import Typography from '@components/Atoms/Typography';
import ScrollWrapper from '@components/Atoms/ScrollWrapper';
import Button from '@components/Atoms/Button';
import ShowIf from '@components/Atoms/ShowIf';
import SettingsIcon from '@mui/icons-material/Settings';

import { useIsTeacher } from '@reducers/user/hooks';
import NavTestSessionsList from './Nav/NavTestSessionsList';
import ManageTestSessions from './ManageTests/ManageTestSessions';

const pathName = '/tests/course';
const LeftSideBar = () => {
  const [isManageTestSessionsOpen, setIsManageTestSessionsOpen] = useState(false);
  const { courseId } = useParams();
  const isSideBarClose = useSelector(selectors.getSideBar);
  const dispatch = useDispatch();
  const isTeacher = useIsTeacher();
  const toggleLeftSidebar = () => dispatch(actions.toggleLeftSidebar());

  const shouldDisplaySectionSelect = !!courseId;
  return (
    // @ts-ignore
    <LeftSiderBarWrap isClose={isSideBarClose as boolean} data-testid="exam-left-sidebar" role="complementary" aria-label="Exam navigation">
      {/* Visually-hidden h1 inside the landmark so it's always in DOM and satisfies page-has-heading-one
          without region violation. LeftSiderBarWrap is outside ExamSectionsWrapper's Suspense boundary
          so this h1 renders immediately regardless of data-loading state. */}
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }}>
        Exams
      </h1>
      <LeftSiderBarHeader>
        <LeftSiderBarHeaderGroup>
          <CourseSelect pathName={pathName} />
          {shouldDisplaySectionSelect && <SectionSelect pathName={pathName} />}
        </LeftSiderBarHeaderGroup>
      </LeftSiderBarHeader>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          borderRadius: 1,
          px: 2,
          flex: 1,
        }}
      >
        <Typography
          variant="h4"
          component="h2"
          sx={{
            py: 2,
            fontWeight: 'bold',
            fontSize: '1.25rem',
            color: '#939393',
          }}
        >
          {isManageTestSessionsOpen ? 'Manage Test Sessions' : 'Test Sessions'}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 'fit-content',
            pb: 2,
          }}
        >
          <ShowIf If={!isManageTestSessionsOpen && isTeacher}>
            <Button
              variant="outlined"
              onClick={() => setIsManageTestSessionsOpen(true)}
              fullWidth
              startIcon={<SettingsIcon />}
            >
              manage test sessions
            </Button>
          </ShowIf>
          <ShowIf If={isManageTestSessionsOpen && isTeacher}>
            <Button
              variant="outlined"
              onClick={() => setIsManageTestSessionsOpen(false)}
              fullWidth
            >
              cancel
            </Button>
          </ShowIf>
        </Box>
        <ScrollWrapper sx={{ height: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              height: 'fit-content',
            }}
          >
            <ExamSectionsWrapper>
              <ShowIf If={!isManageTestSessionsOpen}>
                <NavTestSessionsList />
              </ShowIf>
              <ShowIf If={isManageTestSessionsOpen}>
                <ManageTestSessions />
              </ShowIf>
            </ExamSectionsWrapper>
          </Box>
        </ScrollWrapper>
      </Box>
      {/* Action to show/hide the sidebar */}
      <ActionShowHide className="toggle-icon" onClick={toggleLeftSidebar} data-testid="left-sidebar-toggle">
        <MediaQuery maxWidth={960}>
          {(matches) =>
            matches ? (
              <span
                className={isSideBarClose ? 'chalktalk-icon-bold-up' : 'chalktalk-menu'}
              />
            ) : (
              <span
                className={isSideBarClose ? 'chalktalk-menu' : 'chalktalk-icon-bold-up'}
              />
            )
          }
        </MediaQuery>
      </ActionShowHide>
    </LeftSiderBarWrap>
  );
};

export default LeftSideBar;
